import React, { useState } from "react";
import { imageUrl } from "../../../constants/constants";
import Slider from "react-slick";
import Viewer from "react-viewer";

const EventCard = ({ selectedEvent }) => {
  const [visible, setVisible] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [currentImages, setCurrentImages] = useState([]);

  const handleImageClick = (images) => {
    if (images) setVisible(true);

    setCurrentImages(
      images.map((img) => ({
        src: `${process.env.REACT_APP_IMAGE_URL}/${img.file_path}`,
        alt: img.title,
      }))
    );
    setActiveIndex(0);
  };

  const settings = {
    dots: true,
    arrow: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    customPaging: (i) => (
      <button>
        <span className="dot" />
      </button>
    ),
    dotsClass: "slick-dots custom-dots",
    fade: true,
  };
  return (
    <>
      <Slider {...settings}>
        {selectedEvent?.field_upload_image?.map((item) => (
          <div
            className="card-sec"
            onClick={() => handleImageClick(selectedEvent.field_upload_image)}
          >
            <div className="img-sec">
              <img
                src={
                  item.file_path
                    ? imageUrl + item.file_path
                    : "images/dummy.png"
                }
                alt={item.title}
              />
            </div>
          </div>
        ))}
      </Slider>
      <Viewer
        visible={visible}
        onClose={() => setVisible(false)}
        onMaskClick={() => setVisible(false)}
        images={currentImages}
        activeIndex={activeIndex}
        rotatable={false}
        zoomable={true}
        scalable={false}
        drag={false}
        // downloadable={true}
      />
    </>
  );
};

export default EventCard;
